import { Typography } from '@mui/material';
import React from 'react';

interface Props {
  children?: React.ReactNode;
  testId?: string;
}

export function Value(props: Props) {
  const { children, testId } = props;
  return (
    <Typography component='div' data-testid={testId}>
      {children}
    </Typography>
  );
}
